type IFontSizeKey =
  | "title"
  | "huge"
  | "regular"
  | "big"
  | "medium"
  | "small"
  | "tiny";

const fontSize: { [key in IFontSizeKey]: string } = {
  huge: "24px",
  title: "20px",
  big: "18px",
  regular: "16px",
  medium: "15px",
  small: "14px",
  tiny: "12px",
};

export default {
  ...fontSize,
};
